import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import noCommon from './locales/no/common.json';
import thCommon from './locales/th/common.json';
import enCommon from './locales/en/common.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      no: {
        common: noCommon
      },
      th: {
        common: thCommon
      },
      en: {
        common: enCommon
      }
    },
    defaultNS: 'common',
    fallbackLng: 'en',
    lng: 'no',
    supportedLngs: ['no', 'th', 'en'],
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
